import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input } from '@angular/core';
import { RetailService } from '../../../core/routing/services/retail_api/retail.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { AppGlobal } from '../../../core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { CommonService } from '../../../../app/common/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'iposcen-profile-tabs',
  templateUrl: './profile-tabs.component.html',
  styleUrls: ['./profile-tabs.component.scss']
})
export class ProfileTabsComponent implements OnInit {
  tabIndex:number;
  viewDevicesClicked: boolean = false;
  packageData:any = {};
  iposLegalVersion: string;
  retailerId: string;
  userId: string;
  isOverTheAirUpdatesEnabled: boolean;
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  globConst = GlobalConstants;
  currentPage: string;
  OTAData = false;
  isIposLite:boolean = false;

  private ngUnsubscribe = new Subject<boolean>();
  constructor(private router: Router,
    private appGlobal: AppGlobal,
    private cmnService: CommonService,
    private retailHqService: RetailService) { }
    
    ngOnInit(): void {
    this.retailerId = sessionStorage.getItem('retailerId');
    this.currentPage = this.router.url;
    const pageName = this.currentPage.lastIndexOf('/');
    if (this.currentPage.substring(pageName + 1) === GlobalConstants.PROFILE_UPDATEIPOS){
      this.tabIndex = 1;
      this.getLatestIPOSVersion();
    } else this.tabIndex = 0;
    this.appGlobal.$userAccount
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(async (userAccount: User) => {
      if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
        const retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId,this.retailerId);
        this.isOverTheAirUpdatesEnabled = retailerConfig?.enableUpdateIPOSOverTheAir ? retailerConfig?.enableUpdateIPOSOverTheAir : false;
      }else{
        this.isOverTheAirUpdatesEnabled = false;
      }
      this.OTAData = true;
    });
    this.cmnService.viewDevicesObser.subscribe(res => {
      this.packageData = res;
      this.viewDevicesClicked = true;
      this.isIposLite = res.profileId.split('|')[1] === 'iposlite';
    });
  }
  setIndex(index: number) {
    if (index == 0) {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.PROFILE_PAGE);
    } else {
      this.router.navigateByUrl(GlobalConstants.SLASH + GlobalConstants.PROFILE_PAGE + GlobalConstants.SLASH + GlobalConstants.PROFILE_UPDATEIPOS);
    }
  }
  getLatestIPOSVersion() {
    this.retailHqService.getDateandYear()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getHomePageResponse => {
        this.iposLegalVersion = getHomePageResponse?.iposLegalVersion;
      });
  }
  navToMainStream(){
    this.packageData = {};
    this.viewDevicesClicked = false;
    this.tabIndex = 1;
  }
}
